import { useGetCompaniesQuery } from '../../Companies/Service/companiesApi';
import {
  mapCompanyToBankDocumentLookup,
  type BankDocumentCompanyLookup,
} from './companiesLookupMapper';

export const useGetBankDocumentCompaniesLookupQuery = (): {
  companies: BankDocumentCompanyLookup[];
  isLoading: boolean;
} => {
  const { data, isLoading } = useGetCompaniesQuery();

  const companies: BankDocumentCompanyLookup[] = (data ?? [])
    .map(mapCompanyToBankDocumentLookup)
    .filter((item): item is BankDocumentCompanyLookup => item !== undefined)
    .sort((a, b) => a.name.localeCompare(b.name, 'pl'));

  return { companies, isLoading };
};
